import { Grid } from "@mui/material";
import type { ReactNode } from "react";

function getGridSize(index: number, actionsLength: number) {
  const isLastAction = index === actionsLength - 1;
  const hasEvenActions = actionsLength % 2 === 0;

  return {
    xs: isLastAction ? (hasEvenActions ? 6 : 12) : 6,
    lg: 12 / actionsLength,
  };
}

type Props = {
  children: ReactNode;
};

function ViewDeliveryActionGrid({ children }: Props) {
  const actions = Array.isArray(children)
    ? children.filter(Boolean)
    : children != null
      ? [children]
      : [];

  return actions.map((action, index) => (
    <Grid
      key={(action as { key?: string }).key ?? `delivery-action-${index}`}
      size={getGridSize(index, actions.length)}
    >
      {action}
    </Grid>
  ));
}

export default ViewDeliveryActionGrid;
